import React from 'react';

const RevertButton = ({ match, setCleanParsedEstData, setCleanParsedInsData, onClick }) => {
  const revertButton = {
    padding: '6px 8px',
    cursor: 'pointer',
    backgroundColor: '#bac2c3',
    fontWeight: 'bold',
    color: 'white',
    border: 'none',
    width: '120px'
  };

  return (
    <button
      style={revertButton}
      type="button"
      onClick={() => onClick(match)}
      title="Revert this match ONLY to what the system detected. Specifically, the line items and zone declarations for those line items. Also, all line items in question will be unlocked."
    >
      REVERT
    </button>
  );
};

export default RevertButton;
